
// @ts-nocheck - Disable TypeScript checking for legacy Vue 3 Options API compatibility
import {defineComponent} from "vue";
import Swal from "sweetalert2";
import FormInput from "./FormInput.vue";
import AddressFields from "./AddressFields.vue";

interface CompanyData {
  alias_goldylocks: string;
  email: string;
  nome_goldylocks: string;
  morada_goldylocks: string;
  cp_goldylocks: string;
  localidade_goldylocks: string;
  nif_goldylocks: string;
  plan_id: number;
}

interface Plan {
  id_plano: number;
  codigo_plano: string;
  nome_plano: string;
  valor_mensal: string;
  valor_anual: string;
  designacao_html: string;
  extensao: string;
}



export default defineComponent({
  name: "CreateCompanyForm",
  components: { FormInput, AddressFields },
  data() {
    return {
      dadosEmpresa: {
        alias_goldylocks: "",
        email: "",
        nome_goldylocks: "",
        morada_goldylocks: "",
        cp_goldylocks: "",
        localidade_goldylocks: "",
        nif_goldylocks: "",
        plan_id: 0
      },
      minimumAliasChars: 8,
      isCreating: false,
      isLoadingPlans: false,
      plansLoadError: false,
      plans: [],
    }
  },
  computed: {
    validAlias() {
      return (this.dadosEmpresa.alias_goldylocks.length >= this.minimumAliasChars)
    },
    onlyPlans() {
      return this.plans.filter(plan => {
        return plan['extensao'] === "0"
      });
    },
    selectedPlanInfo(): Plan | null {
      let selectedPlan = this.onlyPlans.filter(plan => {
        return (plan['id_plano'] === this.dadosEmpresa.plan_id)
      })

      return selectedPlan.length > 0 ? selectedPlan[0] : null
    },
    isFormValid() {
      return this.isAliasValid &&
             this.isNifValid &&
             /^\d{4}-\d{3}$/.test(this.dadosEmpresa.cp_goldylocks) &&
             /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.dadosEmpresa.email) &&
             this.dadosEmpresa.nome_goldylocks.length >= 2 &&
             this.dadosEmpresa.morada_goldylocks.length >= 5 &&
             this.dadosEmpresa.localidade_goldylocks.length >= 2 &&
             this.dadosEmpresa.plan_id > 0 &&
             !this.plansLoadError &&
             !this.isLoadingPlans;
    },
    isNifValid() {
      return /^\d{9}$/.test(this.dadosEmpresa.nif_goldylocks);
    },
    isAliasValid() {
      return /^[a-zA-Z0-9_-]{3,50}$/.test(this.dadosEmpresa.alias_goldylocks);
    },
  },
    onlyPlans(this: any) {
      return this.plans.filter(plan => {
        return plan['extensao'] === "0"
      });
    },
    selectedPlanInfo(this: any): Plan | null {
      let selectedPlan = this.onlyPlans.filter(plan => {
        return (plan['id_plano'] === this.dadosEmpresa.plan_id)
      })

      return selectedPlan.length > 0 ? selectedPlan[0] : null
    },
    isFormValid(this: any) {
      return this.validAlias &&
             this.isNifValid &&
             this.dadosEmpresa.cp_goldylocks.match(/^\d{4}-\d{3}$/) &&
             this.dadosEmpresa.email.match(/^[^@]+@[^@]+\.[^@]+$/) &&
             this.dadosEmpresa.plan_id > 0;
    },
    isNifValid(this: any) {
      return /^\d{9}$/.test(this.dadosEmpresa.nif_goldylocks);
    },
  methods: {
    sanitizeTextInput(input: string): string {
      if (!input) return input;
      return input
        .replace(/[<>'"&]/g, '') // Remove HTML special characters
        .replace(/javascript:/gi, '') // Remove javascript: protocol
        .replace(/vbscript:/gi, '') // Remove vbscript: protocol
        .replace(/on\w+\s*=/gi, '') // Remove event handlers
        .replace(/style\s*=\s*["'][^"']*["']/gi, '') // Remove style attributes
        .replace(/src\s*=\s*["'][^"']*["']/gi, '') // Remove src attributes
        .replace(/data:\s*["'][^"']*["']/gi, '') // Remove data: URIs
        .replace(/<!--[\s\S]*?-->/g, '') // Remove HTML comments
        .replace(/(\b(SELECT|INSERT|UPDATE|DELETE|DROP|CREATE|ALTER|EXEC|UNION|SCRIPT)\b)/gi, '') // Basic SQL injection prevention
        .trim()
        .substring(0, 255); // Limit length to prevent buffer overflow
    },
    validateNifInput(event: Event) {
      const target = event.target as HTMLInputElement;
      // Remove any non-digit characters
      target.value = target.value.replace(/\D/g, '');
      this.dadosEmpresa.nif_goldylocks = target.value;
    },
    validateAliasInput(event: Event) {
      const target = event.target as HTMLInputElement;
      // Allow only alphanumeric, hyphens, and underscores
      let value = target.value.replace(/[^a-zA-Z0-9_-]/g, '');
      // Sanitize and limit length
      value = this.sanitizeTextInput(value).substring(0, 50);
      target.value = value;
      this.dadosEmpresa.alias_goldylocks = value;
    },
    createGoldylocks() {
      if (this.isFormValid) {
        this.isCreating = true;
        this.$store.dispatch('createNewCompany', this.dadosEmpresa)
            .then(() => {
              this.isCreating = false;
              this.dadosEmpresa = {
                alias_goldylocks: "",
                email: "",
                nome_goldylocks: "",
                morada_goldylocks: "",
                cp_goldylocks: "",
                localidade_goldylocks: "",
                nif_goldylocks: "",
                plan_id: 0
              }

              Swal.fire({
                icon: `success`,
                html: `Pedido de criação submetido com <strong>sucesso</strong>!<br><span>Receberá um email com as credenciais de acesso dentro de momentos.</span>`,
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: `OK`,
                confirmButtonColor: `#3ec487`,
              })
            })
            .catch(() => {
              this.isCreating = false;
            })
       } else {
         Swal.fire({
           icon: 'error',
           title: 'Erro de validação',
           text: `Por favor, verifique os campos do formulário.`,
           confirmButtonColor: '#f14668'
         });
       }
    },
    fetchPlans() {
      this.isLoadingPlans = true;
      this.plansLoadError = false;

      // Add timeout to prevent hanging indefinitely
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Timeout')), 10000); // 10 second timeout
      });

      Promise.race([
        this.$store.dispatch('fetchPlans'),
        timeoutPromise
      ])
          .then(plans => {
            this.plans = plans;
            this.plansLoadError = false;
          })
          .catch((error: any) => {
            console.error('Erro ao carregar planos:', error);
            this.plansLoadError = true;
            const errorMessage = error.message === 'Timeout'
              ? 'A ligação expirou. Verifique a sua conexão e tente novamente.'
              : 'Não foi possível carregar os planos. Verifique a sua conexão e tente novamente.';
            Swal.fire({
              icon: 'error',
              title: 'Erro ao carregar planos',
              text: errorMessage,
              confirmButtonColor: '#f14668'
            });
          })
          .finally(() => {
            this.isLoadingPlans = false;
          });
    }
  },
  mounted() {
    this.fetchPlans();
  }
})
